export const queryKeys = {
  bankSummary: 'bankSummary',
  bank: 'bank',
  entitySummary: 'entitySummary',
  entitySummaryFilter: 'entitySummaryFilter',
  entity: 'entity',
  obmEmployee: 'obmEmployee',
}
